import { urlFor } from '~/utils/sanity';
import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
import Container from '~/components/sanity/Container.vue';
export default {
  name: 'Feature2',
  components: {
    SanityBlockContent,
    Container
  },
  props: {
    content: Object,
    styles: Object
  },
  data() {
    return {
      heading: this.content.heading,
      subheading: this.content.subheading,
      list: this.content.list
    };
  },
  computed: {
    style() {
      if (!this.styles) {
        return {
          color: '#FFFFFF',
          backgroundColor: '#000000'
        };
      }
      let style = {
        color: this.styles.color || '#FFFFFF'
      };
      if (this.styles.backgroundType === 'image') {
        style = {
          ...style,
          backgroundImage: `url(${this.styles.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        };
      } else if (this.styles.backgroundType === 'color') {
        style.backgroundColor = this.styles.backgroundColor;
      } else {
        style.backgroundColor = '#000000';
      }
      return style;
    }
  },
  methods: {
    imageUrl(image) {
      return urlFor(image);
    }
  }
};